import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../../services/ApiService';


const AddUpdate = () => {
  

  const { id } = useParams();
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    password: '',
    picture: '',
    role_id: '',
  });


  useEffect(() => {
    getRolesList();

    if (id) {
      getSingleData();
    }
    
  }, [id]);
 

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `admin/system-users/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const userData = data.data;
        setIsSuperUser(userData.is_super_user || false);
        // Handle role_id - it might be an object when populated or just an ID
        const roleId = userData.role_id && typeof userData.role_id === 'object' 
          ? userData.role_id._id || userData.role_id.id 
          : userData.role_id;
        setFormData({
          ...userData,
          // null would be sent as the string "null" by FormData.
          username: userData.username || '',
          email: userData.email || '',
          password: '',
          role_id: roleId || ''
        });
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const getRolesList = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `admin/roles-list`,
      });
      const data = response.data;
      if (data.status) {
        setRoles(data.data);
      
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.username.trim() && !formData.email.trim()) {
      toast.error('Enter a username or an email');
      return;
    }
    if (!id && !formData.password) {
      toast.error('Password is required');
      return;
    }
    setIsLoader(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });
    

      const response = await ApiService.request({
        method: 'POST',
        url: `admin/system-users/createOrUpdate/${id || ''}`,
        data,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/admin/system-users/');
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? ('Edit System User') : ('Add System User')} 
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/admin/dashboard" className="text-muted text-hover-primary">{('Dashboard')} </Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/auctions" className="text-muted text-hover-primary">{('System Users')} </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> {('Name')}</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder={('Name')}
                      required
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2"> {('Username')}</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder={('e.g. frontdesk')}
                      name="username"
                      autoComplete="off"
                      maxLength={30}
                      value={formData.username}
                      onChange={(e) => setFormData((prev) => ({ ...prev, username: e.target.value.toLowerCase().replace(/\s/g, '') }))}
                    />
                    <div className="form-text">Letters, numbers, dots, dashes or underscores. Can be used to log in instead of email.</div>
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2"> {('Email')}</label>
                    <input
                      type="email"
                      className="form-control form-control-solid"
                      placeholder={('Email')}
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <div className="form-text">Optional when a username is set — at least one is required.</div>
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className={`${id ? '' : 'required'} fs-6 fw-semibold mb-2`}> {('Password')}</label>
                    <input
                      type="password"
                      className="form-control form-control-solid"
                      placeholder={('Password')}
                      
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>
                   <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2"> 
                      {('Role')}
                      {isSuperUser && <span className="badge badge-light-warning ms-2">Super User - No Role Needed</span>}
                    </label>
                    {isSuperUser ? (
                      <div className="form-control form-control-solid" style={{ padding: '0.75rem', backgroundColor: '#f3f6f9' }}>
                        <span className="text-muted">Super users have all permissions and don't require a role</span>
                      </div>
                    ) : (
                      <select 
                        value={formData.role_id && typeof formData.role_id === 'object' 
                          ? (formData.role_id._id || formData.role_id.id) 
                          : formData.role_id} 
                        name='role_id' 
                        onChange={handleChange} 
                        className='form-select'
                        required={!isSuperUser}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role, index) => (
                          <option key={index} value={role._id || role.id}>{role.name}</option>
                        ))}
                      </select>
                    )}
                  </div>


                </div>
       


                <br />
                
                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to="/admin/system-users" className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : ('Submit')}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdate;
